module.exports = __webpack_public_path__ + "img/nosotros_16-9_640.f24173fb.webp";